<div mat-button [matMenuTriggerFor]="menu" class="mb-4 cursor-pointer" i18n-title title="Zobraziť ďalšie možnosti">
  <a><b>{{zaverecnaPraca.typ}} - {{zaverecnaPraca.nazov ? zaverecnaPraca.nazov : zaverecnaPraca.nazovPrimarny}}</b></a>
  <div *ngIf="zaverecnaPraca.verzia"><span class="fw-bold" i18n>Verzia</span>: {{zaverecnaPraca.verzia}}</div>
  <div><span class="fw-bold" i18n>Stav</span>:&nbsp;{{zaverecnaPraca.stav}}</div>
  <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
</div>

<mat-menu #menu="matMenu">

  <button mat-menu-item class="small" (click)="odhlasit()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Odhlásiť sa z práce</span>
  </button>

  <hr/>

  <button mat-menu-item class="small" (click)="detailZadania()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Detail zadania</span>
  </button>

  <button mat-menu-item class="small" (click)="detailPraceHodnoteniePosudok()">
    <mat-icon>fiber_manual_record</mat-icon>
    <span i18n>Detail práce, hodnotenie, posudok</span>
  </button>

  <section *ngIf="zaverecnaPraca.tlacZadania">
    <hr/>

    <button mat-menu-item class="small" (click)="tlacPrihlasky()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Tlač prihlášky</span>
    </button>

    <button mat-menu-item class="small" (click)="tlacZadania()">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Tlač zadania</span>
    </button>

    <button mat-menu-item class="small" (click)="tlacZadania('ENX')">
      <mat-icon>fiber_manual_record</mat-icon>
      <span i18n>Tlač jazykovej mutácie</span>
    </button>
  </section>

</mat-menu>
